import { Routes } from '@common/constants';
import { useLabels } from '@features/Menu/useLabels';
import { useTranslations } from '@lang';
import React from 'react';
import { Item } from '../../common';
import { StyledHeader } from '../Items.styles';

export type NavMenuProps = {
  isRoomsIntegrated?: boolean;
  isTablesIntegrated?: boolean;
  isRetailEnabled?: boolean;
  isSpaTreatmentEnabled?: boolean;
  isFacilitiesEnabled?: boolean;
  isSpaClassesEnabled?: boolean;
  isSpaDaysEnabled?: boolean;
  isSpaStaysEnabled?: boolean;
  websiteUrl?: string;
};

export const NavMenu: React.FC<NavMenuProps> = ({
  isRoomsIntegrated = false,
  isTablesIntegrated = false,
  isRetailEnabled = false,
  isSpaTreatmentEnabled = false,
  isFacilitiesEnabled = false,
  isSpaClassesEnabled = false,
  isSpaDaysEnabled = false,
  isSpaStaysEnabled = false,
}) => {
  const { t } = useTranslations();
  const labels = useLabels();

  return (
    <>
      <StyledHeader>{t('flynav.browseBy')}</StyledHeader>
      <Item
        route={Routes.ROOM_LIST}
        display={isRoomsIntegrated}
        message={labels?.rooms ?? t('flynav.rooms')}
      />
      <Item
        route={Routes.RATE_LIST}
        display={isRoomsIntegrated}
        message={labels?.rates ?? t('flynav.rates')}
      />
      <Item
        route={Routes.SPA_DAY_LIST}
        display={isSpaDaysEnabled}
        message={labels?.spadays ?? t('flynav.spaDays')}
      />
      <Item
        route={Routes.SPA_STAYS_LIST}
        display={isSpaStaysEnabled}
        message={labels?.spastays ?? t('flynav.spaStays')}
      />
      <Item
        route={Routes.SPA_TREATMENT_LIST}
        display={isSpaTreatmentEnabled}
        message={labels?.treatments ?? t('flynav.treatments')}
      />
      <Item
        route={Routes.SPA_CLASSES_LIST}
        display={isSpaClassesEnabled}
        message={labels?.classes ?? t('flynav.classes')}
      />
      <Item
        route={Routes.FACILITY_LIST}
        display={isFacilitiesEnabled}
        message={labels?.facilities ?? t('app.facilities')}
      />
      <Item
        route={Routes.TABLES_HOME}
        display={isTablesIntegrated}
        message={labels?.tables ?? t('flynav.dining')}
      />
      <Item
        route={Routes.PRODUCT_LIST}
        display={isRetailEnabled}
        message={labels?.retail ?? t('flynav.shop')}
      />
      <Item
        route={Routes.CATEGORY_LIST}
        display={isRetailEnabled}
        message={labels?.categories ?? t('flynav.categories')}
      />
    </>
  );
};
